import { render, staticRenderFns } from "./generalagentdashboard.vue?vue&type=template&id=211c3f16"
import script from "./generalagentdashboard.vue?vue&type=script&lang=js"
export * from "./generalagentdashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports